import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, ToastController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { NavController, AlertController } from 'ionic-angular';
import { App } from 'ionic-angular';
import { Push, PushObject, PushOptions } from '@ionic-native/push';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  counter: any = 0;
  rootPage: any = 'AuthPage';
  @ViewChild(Nav) nav: Nav;
  constructor(public push: Push, public app: App, private alertCtrl: AlertController, private platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, public toastCtrl: ToastController) {

    splashScreen.hide();
    platform.ready().then(() => {
      statusBar.styleDefault();
      this.pushsetup();

      platform.registerBackButtonAction(() => {
        let nav = app.getActiveNavs()[0];
        let activeView = nav.getActive();

        //.. added authpage to check active view on press back exit  
        if (activeView.name === 'HomePage' || activeView.name === 'AdminPage' || activeView.name === 'HrAdminPage' || activeView.name === 'AuthPage') {

          if (this.counter == 0) {
            this.counter++;
            this.presentToast();
            setTimeout(() => { this.counter = 0 }, 3000)
          } else {
            // console.log("exitapp");
            platform.exitApp();
          }
        }
        else {
          // go to previous page
          this.nav.pop({});
        }

      }, 0)
    });

  }
  presentToast() {
    let toast = this.toastCtrl.create({
      message: "Press again to exit",
      duration: 3000,
      position: "middle"
    });
    toast.present();

  }
  pushsetup() {
    const options: PushOptions = {
      android: {
        senderID: '168263241728'
      },
      ios: {
        alert: 'true',
        badge: true,
        sound: 'false'
      },
      windows: {}
    };

    const pushObject: PushObject = this.push.init(options);

    pushObject.on('notification').subscribe((notification: any) => {
      if (notification.additionalData.foreground) {
        let youralert = this.alertCtrl.create({
          title: 'New Push notification',
          message: notification.message
        });
        youralert.present();
      }
    });

    pushObject.on('registration').subscribe((registration: any) => {
      //do whatever you want with the registration ID
    });

    pushObject.on('error').subscribe(error => alert('Error with Push plugin' + error));
  }
}


// import { AdminPanelPageModule } from '../pages/admin-panel/admin-panel.module';
// import { AuthPage } from '../pages/auth/auth';
// import { LoginPage } from '../pages/login/login';
// import { HrAdminPage } from '../pages/hr-admin/hr-admin';


// WEBPACK FOOTER //
// ./src/app/app.component.ts